import type * as sdk from '@seek/hirer-job-application-service-sdk';
import type { Language } from '@seek/melways-sites';

import type { ApplicationAttachmentType } from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import { ATTACHMENT_TYPES } from 'src/constants/attachmentTypes';

import configurationService from '../services/configurationService';

export const NON_PDF_ATTACHMENT_TYPE_MAPPING: Record<
  ApplicationAttachmentType,
  sdk.GetApplicationAttachment.RequestInput['attachmentType']
> = {
  COVER_LETTER: 'CoverLetter',
  RESUME: 'Resume',
  REFERENCE_CHECK: 'ReferenceCheck',
  SELECTION_CRITERIA: 'SelectionCriteria',
  OTHER: 'CandidateSupportDoc',
};

export const NON_PDF_ATTACHMENT_TYPE_NUMBER_MAPPING: Record<
  ATTACHMENT_TYPES,
  sdk.GetApplicationAttachment.RequestInput['attachmentType']
> = {
  [ATTACHMENT_TYPES.RESUME]: 'Resume',
  [ATTACHMENT_TYPES.COVER_LETTER]: 'CoverLetter',
  [ATTACHMENT_TYPES.REFERENCE_CHECK]: 'ReferenceCheck',
  [ATTACHMENT_TYPES.SELECTION_CRITERIA]: 'SelectionCriteria',
  [ATTACHMENT_TYPES.HIRER_UPLOADED]: 'CandidateSupportDoc',
};

const languageChecker = (lang: string) =>
  ['en', 'th', 'id'].includes(lang) ? lang : 'en';

export const attachmentUrlV2 = ({
  jobId,
  applicationCorrelationId,
  attachmentType,
  actionType,
  attachmentId,
  version,
  language,
}: Omit<sdk.GetApplicationAttachment.RequestInput, 'lang'> & {
  version: string;
  language?: Language;
}) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';

  const lang = language ? languageChecker(language) : 'en';

  const searchParams = new URLSearchParams();
  searchParams.append('jobId', jobId);
  searchParams.append('applicationCorrelationId', applicationCorrelationId);
  searchParams.append('attachmentType', attachmentType);
  searchParams.append('actionType', actionType);
  searchParams.append('attachmentId', attachmentId);

  if (attachmentType === 'ReferenceCheck') {
    searchParams.append('lang', lang);
    // FIXME: refCheck this is a temporary fix for the reference check cloudflare caching issue.
    searchParams.append('version', version);
  }

  return `${prefix}/attachment/applications?${searchParams.toString()}`;
};

export const mapStoreAttachmentTypeToRequestInput = (
  typeNum: ATTACHMENT_TYPES,
  pdfConverted?: boolean,
): sdk.GetApplicationAttachment.RequestInput['attachmentType'] => {
  switch (typeNum) {
    case ATTACHMENT_TYPES.RESUME:
      return pdfConverted ? 'PdfConvertedResume' : 'Resume';
    case ATTACHMENT_TYPES.COVER_LETTER:
      return pdfConverted ? 'PdfConvertedCoverLetter' : 'CoverLetter';
    case ATTACHMENT_TYPES.REFERENCE_CHECK:
      return 'ReferenceCheck';
    case ATTACHMENT_TYPES.SELECTION_CRITERIA:
      return pdfConverted
        ? 'PdfConvertedSelectionCriteria'
        : 'SelectionCriteria';
    default:
      return 'CandidateSupportDoc';
  }
};
